export default __webpack_public_path__ + "static/media/zeroGuide2.f98e6edc.png";